import { Link } from "react-router";
import { LandingButton } from "../button/landing_button";
import { CircularAvatar } from "../circularavatar/circular-avatar";
import { UpperSectionCard } from "./upper-section-card";
import { upperSectionCardsData } from "./upper-section-card-data";
import { UpperSectionCardRow } from "./upper-section-card-row/upper-section-card-row";
import { RoundedBlueAbsoluteContainer } from "./rounded-blue-absolute-container";
import { CircularAvatarColumn } from "./circular-avatar-column";
import data_analytic_image from "../assets/images/data_analytic.png";
import { HeaderImageWrapper } from "../header/header-image-wrapper";
import { FlexibleRow } from "./flexible-row";
import { UserStats } from "./user-stats";
import { ResponsivePicCard } from "./responsive-pic-card";
import { RadialGrowBackGround } from "../mid-section/radial-grow-back-ground";
import { HeroSection } from "./hero-section-card";


function UpperSection() {
    return (
        <RoundedBlueAbsoluteContainer>
            <RadialGrowBackGround
                animeDelay={`${Math.random() * 5}s`}
                animeDuration={`${3 + Math.random() * 10}s`}
                topPosition={`${10 + Math.random() * 10}%`}
                leftPosition={`${30 + Math.random() * 20}%`}
            />
            <RadialGrowBackGround
                animeDelay={`${Math.random() * 5}s`}
                animeDuration={`${3 + Math.random() * 6}s`}
                topPosition={`${30 + Math.random() * 40}%`}
                leftPosition={`${20 + Math.random() * 40}%`}
            />
            <div style={{ display: "absolute", top: "10%" }}>
                <FlexibleRow>
                    <HeroSection>
                        <h1>
                            Welcome to Data <br /> Analysis Tool
                        </h1>
                        <p>
                            Turn data into decisions.
                            Our analytical tools gives you clear insight,
                            interactive dashboards, and powerful reports,
                            to help your team grow
                            smarter everyday.
                        </p>
                    </HeroSection>
                    <ResponsivePicCard src={data_analytic_image} alt="data_analytic_image" />
                </FlexibleRow>
            </div>
            <div style={{ display: "absolute" }}>
                <FlexibleRow>
                    <div style={{ display: "flex", gap: "10px" }}>

                        <Link to="/register">
                            <LandingButton bgColor="#1092eeff">Register</LandingButton>
                        </Link>
                        <Link to="/login">
                            <LandingButton bgColor="white" textColor="black">Login</LandingButton>
                        </Link>
                    </div>
                    <div style={{ display: "flex", width: "40%", height: "80px", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                        <UserStats>
                            <p>Institues</p>
                            <h4>50+</h4>
                        </UserStats>
                        <div style={{ borderLeft: "3px solid #509EE3", height: "clamp(50px, 20vh, 60px)" }} />
                        <UserStats>
                            <p>Users</p>
                            <h4>2000+</h4>
                        </UserStats>
                    </div>
                </FlexibleRow>
            </div>


            <UpperSectionCardRow>
                {
                    upperSectionCardsData.map((item, index) =>
                        <UpperSectionCard key={index}>
                            <div>
                                <HeaderImageWrapper src={item.icon} alt={item.title} style={{ width: "30px", height: "30px" }} />
                            </div>

                            <h1>
                                {item.title}
                            </h1>
                            <p>
                                {item.description}
                            </p>
                        </UpperSectionCard>)
                }
            </UpperSectionCardRow> *
        </RoundedBlueAbsoluteContainer>
    );
}

export default UpperSection;